import { render, staticRenderFns } from "./listen-speak.vue?vue&type=template&id=7aa92ac2&scoped=true&"
import script from "./listen-speak.vue?vue&type=script&lang=js&"
export * from "./listen-speak.vue?vue&type=script&lang=js&"
import style0 from "./listen-speak.vue?vue&type=style&index=0&id=7aa92ac2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa92ac2",
  null
  
)

export default component.exports